<template>
  <div>
    <el-dialog title="单位信息验证"
               :visible.sync="dialogVisible"
               width="400px"
               :show-close="false"
               :close-on-click-modal="false"
               :close-on-press-escape="false">
      <el-form :model="loginform"
               ref="loginform">
        <el-form-item label="单位名称"
                      prop="title">
          <el-input v-model="loginform.title"
                    autocomplete="off"
                    style="height: 30px"
                    placeholder="用户名"
                    prefix-icon="el-icon-user"></el-input>
        </el-form-item>
        <el-form-item label="密码"
                      prop="pword">

          <el-input v-model="loginform.pword"
                    autocomplete="off"
                    style="height: 30px"
                    @keyup.enter.native="sublogin"
                    placeholder="密码"
                    prefix-icon="el-icon-lock"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">

        <el-button type="primary"
                   @click="sublogin">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'loginPage',
  data () {
    return {
      dialogVisible: true,
      loginform: { title: "", pword: "" },
      dwform: {}
    }
  },
  methods: {
    //登录验证信息
    sublogin () {
      console.log(this.loginform)
      this.$http.get(this.$Api.departmentLogin, {
        params: { title: this.loginform.title, pword: this.loginform.pword }
      }).then(res => {
        console.log(res.data);
        if (res.data.errcode == 0) {
          this.$message({
            message: '验证成功',
            type: 'success'
          });
          this.dialogVisible = false;
          this.dwform = res.data;
          localStorage.setItem('dwform', JSON.stringify(this.dwform));//将公司信息存入缓存
          localStorage.setItem('loginform', JSON.stringify(this.loginform));//将账号密码存入缓存
          switch (this.dwform.type) {
            case 1:
              this.$router.push("/bzsdw")
              break;
            case 2:
              this.$router.push("/province")
              break;
            case 3:
              this.$router.push("/city")
              break;
            case 4:
              this.$router.push("/county")
              break;
            case 5:
              this.$router.push("/company")
              break;
              case 6:
              this.$router.push("/nation")
              break;
            default:
              break;
          }

        } else {
          this.$message.error("信息有误");
        }
      });
    }
  },
  mounted () {
    this.loginform = JSON.parse(localStorage.getItem('loginform'));//将缓存中的账号密码取出
    if (this.loginform == null) {
      this.loginform = { title: "", pword: "" }
    }
  }
}
</script>

<style lang="less">
.el-dialog {
  background-color: #f2f5f4;
  border-radius: 10px;
  .el-input__inner {
    border-radius: 30px;
    height: 50px;
    padding-left: 40px !important;
  }
  .el-input__prefix {
    height: 55px;
  }
  .el-input__icon {
    font-size: 25px;
    width: 35px;
  }
  .el-input__inner:focus {
    border-color: #117ca3;
  }
  .el-button {
    width: 100%;
    height: 50px;
    border-radius: 30px;
    background-image: linear-gradient(to right, #117ca3, #2cd4d6);
    border: none;
    font-size: 18px;
  }
}
</style>
